/** Constantes layout navigation — aligner avec src/theme/_layout.navigation.scss */
export const NAV_RAIL_WIDTH = 64
export const NAV_DRAWER_WIDTH = 316
export const LAYOUT_HEADER_HEIGHT = 50
export const LAYOUT_HEADER_HEIGHT_SM = 100
export const MENU_EXPANDED_MIN_WIDTH = 1440
